import React, { ReactNode } from 'react';
import ConfigContext, {
    IConfigContextProps,
} from '../../contexts/ConfigContext';
import FrontendContext from '../../contexts/FrontendContext';
import NotificationsContext, {
    INotificationContextInitialState,
} from '../../contexts/NotificationsContext';
import UserContext, {
    IUserContextInitialState,
} from '../../contexts/UserContext';

export interface IAuthInitialState {
    userContextInitialState?: IUserContextInitialState;
    notificationContextInitialState?: INotificationContextInitialState;
}

export interface ILoginProps {
    configuration: IConfigContextProps;
    children: ReactNode;
    initialState?: IAuthInitialState;
}

const ConditionalProvider = ({ context, children, initialState }: any) => {
    let conditionalProvider = children;

    const providerContext = React.useContext(context.Context);

    if (!providerContext) {
        conditionalProvider = (
            <context.Provider initialState={initialState}>
                {children}
            </context.Provider>
        );
    }

    return conditionalProvider;
};

/**
 * Conditional provider component.
 * Allows the exposed providers to be defined externally to this package.
 * This will enable for notifications, user data and any other thing needed to be read and modified outside this package.
 */
const Provider = ({
    configuration,
    children,
    initialState: {
        userContextInitialState,
        notificationContextInitialState,
    } = {},
}: ILoginProps) => {
    return (
        <ConfigContext.Provider value={configuration}>
            <ConditionalProvider context={FrontendContext}>
                <ConditionalProvider
                    context={NotificationsContext}
                    initialState={notificationContextInitialState}
                >
                    <ConditionalProvider
                        context={UserContext}
                        initialState={userContextInitialState}
                    >
                        {children}
                    </ConditionalProvider>
                </ConditionalProvider>
            </ConditionalProvider>
        </ConfigContext.Provider>
    );
};

export default Provider;
